"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getIterator2 = require("babel-runtime/core-js/get-iterator");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _utils = require("./components/utils");

var _utils2 = _interopRequireDefault(_utils);

var _storageProvider = require("../storageProvider");

var _storageProvider2 = _interopRequireDefault(_storageProvider);

var _abp = require("abp");

var _abp2 = _interopRequireDefault(_abp);

var _common = require("../common");

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var emailingApi = {
    identifyUser: function identifyUser(identifySuccessEvent, eventParams) {
        try {
            var identifyData = _storageProvider2.default.getValueSession(emailingApi.customerIdentifiedKey) || {
                date: new Date(0), user: '', anonymous: true
            };
            var minutesBackToReIdentify = window.minutesBackToReIdentify || 20;
            var dateLimit = new Date(new Date().getTime() - minutesBackToReIdentify * 60 * 1000);

            if (identifyData.date < dateLimit || identifyData.user !== _abp2.default.session.email) {
                _abp2.default.services.api.user.getCustomerUser().done(function (result) {
                    if (!result || !result.email) return;
                    _storageProvider2.default.setValueSession(emailingApi.customerIdentifiedKey, {
                        date: new Date(), user: result.email, anonymous: result.isUserAnonymous
                    });

                    emailingApi.identifyVisitor(result.email);

                    if (!result.isUserAnonymous && result.email) {
                        identifySuccessEvent(eventParams);
                    }
                });
            } else if (!identifyData.anonymous && identifyData.user) identifySuccessEvent(eventParams);
        } catch (e) {
            console.error("Error in emailing API method identifyUser", { identifySuccessEvent: identifySuccessEvent, eventParams: eventParams }, e);
        }
    },

    identifyVisitor: function identifyVisitor(userEmail) {
        try {
            if (typeof MkTracker !== 'undefined') MkTracker.identifyVisitor(userEmail);
            if (typeof Boldem !== 'undefined') Boldem.identifyVisitor(userEmail);
        } catch (e) {
            console.error("Error in emailing API method identifyVisitor", { userEmail: userEmail }, e);
        }
    },

    getPushMode: function getPushMode() {
        var customerDetails = _common2.default.getCustomerDetails();
        return _common2.default.convertIntSafe(customerDetails.pushMode);
    },

    updateCart: function updateCart(itemsOriginal) {
        var _this = this;

        try {
            var pushMode = this.getPushMode();
            if ((pushMode & 2) === 2 && _abp2.default && _abp2.default.session) {
                var intro = "Pushing to MK/Boldem updateCart function called, disableMailKomplet:";
                console.debug(" " + intro + " " + !!window.disableMailKomplet + ", session:", _abp2.default.session, "sessionEmail: " + _abp2.default.session.email + ", itemsOriginal: ", itemsOriginal);
            }

            if (window.disableMailKomplet || !itemsOriginal || itemsOriginal.length === 0 || !_abp2.default.session || !_abp2.default.session.email) return;

            this.identifyUser(function (itemsOriginal) {
                var itemsMk = [];
                var itemsBoldem = [];
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(itemsOriginal), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var it = _step.value;


                        var priceVat = ((it.price || {}).unitPrice || {}).finalPrice || 0;
                        var priceNoVat = ((it.price || it.resultPrice || {}).unitPrice || {}).finalPriceWithoutVat || priceVat;
                        var code = it.id || it.productId || 0;

                        var mkRequestBody = {
                            name: it.productName || it.name,
                            amount: it.amount,
                            code: code.toString(),
                            priceVat: priceVat,
                            price: priceNoVat,
                            url: location.origin + "/Product/Detail/" + code,
                            currency: _utils2.default.getCurrencyIntCode(),
                            manufacturer: it.publishingHouseName || it.manufacturer || "",
                            category: Array.isArray(it.categories) && it.categories.length > 0 ? it.categories.map(function (c) {
                                return c.name;
                            }).join(", ") : ""
                        };
                        // data structure for Boldem is slightly different (for some reason)
                        itemsBoldem.push(mkRequestBody);

                        var mkRequestBodyMk = (0, _extends3.default)({}, mkRequestBody, {
                            currency: _utils2.default.skEnvironment() ? _this.currencyEnum.EUR : _this.currencyEnum.CZK,
                            code: code
                        });
                        itemsMk.push(mkRequestBodyMk);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                if ((pushMode & 2) === 2) {
                    console.debug("Pushing to MK/Boldem updateCart, before push. Boldem items:", itemsBoldem, "MK items:", itemsMk);
                    console.debug("MKTracker:", typeof MkTracker !== 'undefined' ? MkTracker : null, "Boldem:", typeof Boldem !== 'undefined' ? Boldem : null);
                    console.debug('Boldem.updateCartContent – sending:', itemsBoldem);
                }
                if (typeof MkTracker !== 'undefined') MkTracker.updateBasketContent(itemsMk);
                if (typeof Boldem !== 'undefined') Boldem.updateCartContent(itemsBoldem);
            }, itemsOriginal);
        } catch (e) {
            console.error("Error in emailing API method updateCart", { itemsOriginal: itemsOriginal }, e);
        }
    },

    completeOrderMessage: function completeOrderMessage() {
        try {
            var pushMode = this.getPushMode();
            if ((pushMode & 2) === 2) {
                console.debug("Pushing to MK/Boldem completeOrderMessage function called, disableMailKomplet:", !!window.disableMailKomplet);
            }

            if (window.disableMailKomplet) return;

            var dataInput = document.getElementById('orderNumberSuccessPageValue');
            if (!dataInput) return;
            var orderNumber = dataInput.value;
            var userEmail = dataInput.dataset.orderEmail;
            var paymentInfo = dataInput.dataset.payment || '';
            var deliveryInfo = dataInput.dataset.delivery || '';
            var alreadyCompletedOrders = _storageProvider2.default.getValueSession(emailingApi.completedOrdersKey) || [];
            // prevent multiple completing in current session
            if (alreadyCompletedOrders.indexOf(orderNumber) > -1) return;

            if ((pushMode & 2) === 2) {
                console.debug("Pushing to MK/Boldem completeOrderMessage, orderNumber:", orderNumber, "userEmail:", userEmail);
                console.debug("MKTracker:", typeof MkTracker !== 'undefined' ? MkTracker : null, "Boldem:", typeof Boldem !== 'undefined' ? Boldem : null);
                console.debug("Sending to Boldem.orderFinished:", {
                    orderNumber: orderNumber,
                    userEmail: userEmail,
                    paymentInfo: paymentInfo,
                    deliveryInfo: deliveryInfo
                });
            }
            if (typeof MkTracker !== 'undefined') MkTracker.sessionCompleted(orderNumber, userEmail);
            if (typeof Boldem !== 'undefined') Boldem.orderFinished(orderNumber, userEmail, { paymentInfo: paymentInfo, deliveryInfo: deliveryInfo });

            alreadyCompletedOrders.push(orderNumber);

            _storageProvider2.default.setValueSession(emailingApi.completedOrdersKey, alreadyCompletedOrders);
        } catch (e) {
            console.error("Error in emailing API method completeOrderMessage", e);
        }
    },

    currencyEnum: { CZK: 5, EUR: 7, USD: 32, GBP: 33 },
    visitorIdentified: false,
    customerIdentifiedKey: 'customer-identified',
    completedOrdersKey: 'completed-orders'
};

exports.default = emailingApi;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/emailingApi.js
// module id = 440
// module chunks = 0 1